import React, { Fragment } from "react";
// import spinner from "./spinner.gif";

const Spinner = () => (
  <Fragment>
    <div className="d-flex align-items-center justify-content-center">
      <hr />
      <br />
      <br />

      {/* <div className="loading-spinner-overlay"> */}
        <div className="loading-spinner"></div>
      {/* </div> */}

      <br />
      <br />
      <br />
      <hr />
    </div>

    {/* <img
      src={spinner}
      style={{ width: "200px", margin: "auto", display: "block" }}
      alt="loading... "
    /> */}
  </Fragment>
);

export default Spinner;
